<template>
  <div id="competition">
    <Topbar v-if="this.$store.state.topbar_actions_visible"></Topbar>
    <CompetitionCategory></CompetitionCategory>

    <div class="section-list">
      <div v-for="(item, index) in sections" class="section">
        <router-link :to="item.url" :event="item.disabled ? '' : 'click'">
          <div class="icon" :class="{ disabled: item.disabled }">
            <router-link :to="item.url + '/add'"
              ><div
                v-if="typeof item.add === 'undefined' || item.add"
                class="add"
              ></div
            ></router-link>
            <img class="img" :src="item.img" />
          </div>
          <div class="content">{{ item.name }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import CompetitionCategory from "@/components/ui/CompetitionCategory";
import Topbar from "@/components/ui/Topbar";

export default {
  name: "Competition",
  components: { CompetitionCategory, Topbar },
  data() {
    return {};
  },
  computed: {
    sections() {
      var oEvent = this.$store.getters["events/getCurrentEvent"]();
      var sections = [
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/stats/top_scores"
          ).replace("//", "/"),
          name: i18n.t("competition.stat.top_score.label"),
          img: "/img/users.svg",
          add: false
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition/stats/team_scores"
          ).replace("//", "/"),
          name: i18n.t("competition.stat.team_score.label"),
          img: "/img/team2.svg",
          add: false
        }
        // {
        //   url: (
        //     this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
        //     "/competition/stats/top_goalkeepers"
        //   ).replace("//", "/"),
        //   name: i18n.t("competition.stat.top_goalkeepers.label"),
        //   img: "/img/users.svg",
        //   add: false
        // }
      ];
      return sections;
    }
  },
  created() {
    var self = this;
    this.$overlay.loading();

    self.$overlay.hide();
  },
  methods: {},
  filters: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#container {
}

#competition {
  overflow-y: auto !important;

  .section-list {
    width: 100%;
    position: relative;
    overflow: hidden;
    text-align: center;

    a {
      text-decoration: none;
    }

    .section {
      width: 125px;
      height: 125px;
      display: inline-block;
      margin: 35px 20px;
      margin-top: 100px;
      position: relative;
      text-align: center;

      .icon {
        width: 80%;
        height: 80%;
        border-radius: 50%;
        padding: 20px;
        position: relative;
        display: inline-block;
        background-color: #222;
        border: 5px solid tint(#222, 70%);
        -webkit-transition: border 200ms ease-out;
        -moz-transition: border 200ms ease-out;
        -o-transition: border 200ms ease-out;
        transition: border 200ms ease-out;

        &.disabled {
          opacity: 0.5;
        }

        .add {
          width: 30px;
          height: 30px;
          background: url("/img/add_2.svg");
          background-color: $complem-color;
          border-radius: 50%;
          border: 1px solid var(--main-color);
          position: absolute;
          top: -5px;
          right: -5px;
          content: " ";
          background-size: 20px;
          background-position: center;
          background-repeat: no-repeat;
          -webkit-transition: all 200ms ease-out;
          -moz-transition: all 200ms ease-out;
          -o-transition: all 200ms ease-out;
          transition: all 200ms ease-out;

          &:hover {
            width: 35px;
            height: 35px;
          }
        }

        &:hover {
          border: 8px solid tint(#222, 70%);
        }

        img {
          position: absolute;
          height: 50%;
          width: auto;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .content {
        width: 100%;
        color: #192461;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        font-family: $text-light;
      }
    }
  }
}
</style>
